<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-space-x-2">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <ts-button outline @click.prevent="onDownloadTemplate">
            {{ $t('task.downLoadTempate') }}
          </ts-button>
          <ts-button outline @click="onClickBrowse">
            {{ $t('task.uploadActionTask') }}
          </ts-button>

          <input type="file" ref="refFile" @change="fileChange" class="ts-hidden" />
        </div>
      </ts-card-wrapper>
      <ts-table-filter :columns="columns" :data="resources" :loading="loading" @search="value => (search = value)">
        <template slot-scope="{ row }" slot="title">
          <a href="#" @click.prevent="onViewTask(row)" class="ts-mb-0 ts-no-underline hover:ts-no-underline">{{
            row.title }}</a>
        </template>
        <template slot-scope="{ row }" slot="status">
          <div class="ts-group">
            <select v-model="row.status_id"
              class="ts-py-1 ts-px-2 ts-rounded ts-outline-none group-hover:ts-hidden hide-select ts-w-32 ts-bg-transparent"
              readonly>
              <option v-for="(s, index) in status" :key="index" :value="s.status_id">{{ s.project_status }}</option>
            </select>
            <div class="group-hover:ts-block ts-hidden">
              <select v-model="row.status_id" class="ts-py-1 ts-px-2 ts-rounded ts-outline-none ts-w-32 hide-select"
                @change="updateColumnValueWhenChange(row, 'status_id')">
                <option v-for="(s, index) in status" :key="index" :value="s.status_id">{{ s.project_status }}</option>
              </select>
            </div>
          </div>
        </template>
        <template slot-scope="{ row }" slot="priority">
          <div class="ts-group">
            <div class="ts-flex ts-space-x-2 ts-items-center group-hover:ts-hidden">
              <div class="ts-h-2 ts-w-2 ts-rounded-full" :class="[priorities[row.priority_id].color]"></div>
              <span>{{ priorities[row.priority_id].label }}</span>
            </div>
            <div class="group-hover:ts-block ts-hidden">
              <select v-model="row.priority_id" class="ts-py-1 ts-px-2 ts-rounded ts-outline-none ts-w-32 hide-select"
                @change="updateColumnValueWhenChange(row, 'priority_id')">
                <option v-for="(p, id) in priorities" :key="id" :value="id">{{
                  p.label
                }}</option>
              </select>
            </div>
          </div>
        </template>
        <template slot-scope="{ row }" slot="owner">
          <div class="ts-group">
            <span class="group-hover:ts-hidden">{{ row.owner_name }}</span>
            <div class="ts-relative group-hover:ts-block ts-hidden" style="z-index: 1024;">
              <div class="ts-absolute ts-top-0 ts--mt-4 ts-z-50">
                <div class="ts-fixed ts-bg-white ts-p-2 ts-rounded-md ts-border ts-border-blue-100" style="z-index: ">
                  <Select v-model="row.owner_id" :filterable="true" style="width:20rem" @on-change="
                    updateColumnValueWhenChange(row, 'owner_id', true)
                    ">
                    <Option v-for="item in owners" :value="item.user_id" :key="item.user_id">{{
                      item.employee_name_kh + ' ' + item.employee_name_en
                    }}</Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="estimated">
          <div @mouseover="onMouseover('show_index_est_date', index)">
            <div style="width: fit-content;" class="group-hover:ts-hidden ts-block"
              v-if="show_index_est_date !== index">
              <Icon type="ios-calendar-outline ts-mr-1" />
              <span>{{ row.estimate_start_date }}</span>
              <Icon type="ios-calendar-outline ts-mr-1 ts-ml-2" />
              <span>{{ row.estimate_end_date }}</span>
            </div>
            <a-range-picker v-if="index === show_index_est_date"
              :value="[row.estimate_start_date, row.estimate_end_date]" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              class="ts-w-full" @change="
                value =>
                  updateColumnValueWhenChange(
                    { ...value, ...row },
                    ['estimate_start_date', 'estimate_end_date'],
                    true
                  )
              " />
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="actual">
          <div @mouseover="onMouseover('show_index_act_date', index)">
            <div style="width: fit-content;" class="group-hover:ts-hidden ts-block"
              v-if="show_index_act_date !== index">
              <Icon type="ios-calendar-outline ts-mr-1" />
              <span>{{ row.actual_start_date }}</span>
              <Icon type="ios-calendar-outline ts-mr-1 ts-ml-2" />
              <span>{{ row.actual_end_date }}</span>
            </div>
            <a-range-picker v-if="index === show_index_act_date" :value="[row.actual_start_date, row.actual_end_date]"
              format="DD-MM-YYYY" valueFormat="DD-MM-YYYY" class="ts-w-full" @change="
                value =>
                  updateColumnValueWhenChange(
                    { ...value, ...row },
                    ['actual_start_date', 'actual_end_date'],
                    true
                  )
              " />
          </div>
        </template>
        <template slot-scope="{ row }" slot="start_name">
          <p class="ts-whitespace-no-wrap ts-mb-0">
            {{ row.start_name !== 'null' ? row.start_name : '' }}
          </p>
        </template>
        <template slot-scope="{ row }" slot="end_name">
          <p class="ts-whitespace-no-wrap ts-mb-0">
            {{ row.end_name !== 'null' ? row.end_name : '' }}
          </p>
        </template>
        <template slot-scope="{ row }" slot="remark">
          {{ limitString(row.remarks) }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <div class="ts-flex ts-space-x-2" style="width: fit-content;">
            <a href="#" class="text-primary" @click.prevent="onEdit(row)" v-tooltip="$t('edit')">
              <Icon type="ios-create" size="20" />
            </a>
            <a href="#" class="text-danger" v-tooltip="$t('delete')" @click="deleteRecord(row)"
              :disabled="row._deleting">
              <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </div>
        </template>
      </ts-table-filter>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination v-model="pagination_task" @navigate="fetchData"></ts-i-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapKeys, camelCase, debounce, trim } from 'lodash'
import * as XLSX from 'xlsx/xlsx.mjs'
import * as FileDownload from 'downloadjs'
import { mapActions } from 'vuex'
import moment from 'moment'

class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}
export default {
  data() {
    return {
      loading: false,
      isOpen: false,
      show_index_est_date: undefined,
      show_index_act_date: undefined,
      pagination: new Pagination(),
      search: '',
      resources: [],
      status: [],
      owners: []
    }
  },
  computed: {
    pagination_task: {
      get() {
        return this.$store.state.projectMgt.projectMilestone.pagination_task
      },
      set(newValue) {
        this.$store.commit(
          'projectMgt/projectMilestone/SET_PAGINATION_TASK',
          newValue
        )
      }
    },
    limitString: () => (text, limit = 20) => {
      if (text != null) {
        let article = text.replace(/(<([^>]+)>)/gi, '')
        return article.length > limit
          ? article.substring(0, limit) + '...'
          : article
      }
      return ''
    },
    priorities() {
      return {
        1: {
          label: 'Low',
          color: 'ts-bg-gray-500'
        },
        2: {
          label: 'Normal',
          color: 'ts-bg-blue-500'
        },
        3: {
          label: 'Meduim',
          color: 'ts-bg-yellow-500'
        },
        4: {
          label: 'Hight',
          color: 'ts-bg-red-600'
        }
      }
    },
    columns() {
      return [
        {
          title: this.$t('task.title'),
          slot: 'title',
          keySearch: 'title',
          minWidth: 200
          // fixed: 'left'
        },
        {
          title: this.$t('task.status'),
          slot: 'status',
          keySearch: 'status.project_status',
          minWidth: 120
          // fixed: 'left'
        },
        {
          title: this.$t('task.estimateQty'),
          key: 'estimate_qty',
          className: 'ts-font-robot ts-whitespace-no-wrap'
        },
        {
          title: this.$t('task.actualQty'),
          key: 'actual_qty',
          className: 'ts-font-robot ts-text-center ts-whitespace-no-wrap'
        },
        {
          title: this.$t('task.priority'),
          slot: 'priority',
          keySearch: 'pri.label',
          minWidth: 120
          // fixed: 'left'
        },
        {
          title: this.$t('task.owner'),
          slot: 'owner',
          keySearch: 'emp.employee_name_en',
          minWidth: 200
          // fixed: 'left'
        },
        {
          title: this.$t('task.estimated'),
          slot: 'estimated',
          minWidth: 220
        },
        {
          title: this.$t('task.startName'),
          slot: 'start_name',
          className: 'ts-font-robot ts-whitespace-no-wrap',
          keySearch: 'start_name'
        },
        {
          title: this.$t('task.endName'),
          slot: 'end_name',
          className: 'ts-font-robot ts-whitespace-no-wrap',
          keySearch: 'end_name'
        },
        {
          title: this.$t('task.actual'),
          slot: 'actual',
          minWidth: 220,
          className: 'ts-font-robot ts-whitespace-no-wrap'
        },
        {
          title: this.$t('task.mobileNumber'),
          slot: 'client_mobile_number',
          className: 'ts-font-robot ts-whitespace-no-wrap',
          keySearch: 'client_mobile_number'
        },
        {
          title: this.$t('task.estimateQty'),
          key: 'estimate_qty',
          className: 'ts-font-robot ts-whitespace-no-wrap'
        },
        {
          title: this.$t('task.createdAt'),
          key: 'created_at',
          minWidth: 200,
          className: 'ts-font-robot ts-whitespace-no-wrap'
        },
        {
          title: this.$t('task.createdBy'),
          key: 'created_by_name',
          keySearch: 'created_by_name',
          minWidth: 120
        },
        {
          title: this.$t('task.project'),
          key: 'project_name',
          minWidth: 200
        },
        {
          title: this.$t('task.remark'),
          slot: 'remark',
          minWidth: 200
        },
        {
          title: this.$t('actions'),
          slot: 'action',
          fixed: 'right',
          align: 'left',
          width: 130
        }
      ]
    }
  },
  created() {
    this.fetchData()
    this.fetchModel()
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', [
      'fetch',
      'destroy',
      'formViewModel',
      'updateColumnValue',
      'downloadTemplate',
      'importTask'
    ]),
    ...mapActions('projectMgt/projectMilestone', ['getTask']),
    addNew() {
      this.$router.push({
        name: 'task-create',
        query: {
          project_id: this.$route.params.project_id,
          milestone_id: this.$route.params.milestone_id
        }
      })
    },
    updateColumnValueWhenChange(row, columns, isNeedFetch = false) {
      let model = {}
      if (Array.isArray(columns)) {
        columns.forEach((el, index) => {
          model[el] = moment(row[index], 'DD-MM-YYYY').isValid()
            ? moment(row[index], 'DD-MM-YYYY').format('YYYY-MM-DD')
            : row[index]
        })
      } else {
        model[columns] = row[columns]
      }
      if (!Object.keys(model).length) return
      this.updateColumnValue({
        id: row.id,
        data: model
      })
        .then(response => {
          this.$toasted.success(response.message)
          if (isNeedFetch) {
            this.fetch()
          }
          this.show_index_est_date = undefined
          this.show_index_act_date = undefined
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    fetchData(attributes) {
      this.loading = true
      let params = Object.assign(
        {},
        {
          page: this.pagination_task.page,
          perPage: this.pagination_task.perPage,
          filter: {
            search: this.search,
            milestone_id: this.$route.params.milestone_id
          }
        },
        attributes
      )
      this.getTask(params)
        .then(response => {
          this.receiveResource(response)
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    fetchModel() {
      this.formViewModel({
        fnName: 'status,owner',
        project_id: this.$route.params.project_id
      })
        .then(response => {
          this.status = response.data.status
          this.owners = response.data.owner
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    onEdit(record) {
      this.$router.push({
        name: 'task-edit',
        params: {
          id: record.id
        }
      })
    },
    deleteRecord(record) {
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.destroy(record.id)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() { }
      })
    },
    onViewTask(record) {
      this.$router.push({
        name: 'task-view',
        params: {
          id: record.id
        }
      })
    },
    onMouseover(key, index) {
      this.show_index_act_date = undefined
      this.show_index_est_date = undefined
      this[key] = index
    },
    receiveResource(response) {
      this.resources = []
      response.data.forEach(resource => {
        this.resources.push(Object.assign(resource, { _deleting: false }))
      })
      if (response.hasOwnProperty('meta')) {
        this.pagination_task = new Pagination(
          mapKeys(response.meta, (v, k) => camelCase(k))
        )
      } else {
        let { ...meta } = response
        this.pagination_task = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
      }
    },
    onDownloadTemplate() {
      this.loading = true
      this.downloadTemplate({
        project_id: this.$route.params.project_id
      })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename + '.xlsx')
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
        .finally(() => (this.loading = false))
    },
    onClickBrowse() {
      this.$refs.refFile.click()
    },
    fileChange(e) {
      this.loading = true
      var file = e.target.files[0]
      var fileName = file.name
      if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = this.readExcelData(data)
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          const workbookData = this.parseWorksheetData(worksheet)
          const sliceFirstRow = workbookData.slice(1)

          if (sliceFirstRow.length > 7) {
            const projectId = this.$route.params.project_id
            const milestoneId = this.$route.params.milestone_id
            const model = sliceFirstRow.slice(8).map(item => ({
              title: item[0],
              priority_id: item[1],
              status_id: item[2],
              owner_id: item[4],
              start_estimate_date: item[5]
                ? this.excelDateToJSDate(item[5])
                : '',
              end_estimate_date: item[6] ? this.excelDateToJSDate(item[6]) : '',
              start_actual_date_date: item[7]
                ? this.excelDateToJSDate(item[7])
                : '',
              end_actual_date_date: item[8]
                ? this.excelDateToJSDate(item[8])
                : '',
              start_name: item[9] ? item[9] : '',
              start_location: {
                lat: item[10] ? item[10].split(',')[0] : '',
                lng: item[10]
                  ? item[10].split(',').length
                    ? item[10].split(',')[1]
                    : null
                  : null
              },
              end_name: item[11] ? item[11] : '',
              end_location: {
                lat: item[12] ? item[12].split(',')[0] : '',
                lng: item[12]
                  ? item[12].split(',').length
                    ? item[12].split(',')[1]
                    : null
                  : null
              },
              location_pin: {
                lat: item[13] ? item[13].split(',')[0] : '',
                lng: item[13]
                  ? item[13].split(',').length
                    ? item[13].split(',')[1]
                    : null
                  : null
              },
              project_id: projectId,
              milestone_id: milestoneId,
              client_mobile_number: item[14] ? item[14] : '',
              estimate_qty: item[15] ? item[15] : '',
              remarks: item[16] ? item[16] : ''
            }))
            this.importTask(model)
              .then(() => this.fetchData())
              .catch(error => {
                const errorValue = error.errors
                  ? Object.values(error.errors)
                  : []
                this.$toasted.error(
                  errorValue.length ? errorValue[0] : error.message
                )
              })
              .finally(() => {
                this.loading = false
                this.$refs.refFile.value = null
              })
          }
        }
      } else {
        this.loading = false
      }
    },
    readExcelData(data) {
      var arr = new Array()
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i])
      }
      var bstr = arr.join('')
      return XLSX.read(bstr, { type: 'binary' })
    },
    parseWorksheetData(worksheet) {
      var jsonData = []
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        const row = {}
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum })
          const cell = worksheet[cellAddress]

          if (cell) {
            // const cellValue = cell ? cell.v : undefined
            row[colNum] = cell.v
          }
        }
        if (Object.keys(row).length) {
          jsonData.push(row)
        }
      }
      return jsonData
    },
    excelDateToJSDate(excelDate) {
      // Adjust for difference in epoch (reference date)
      const EPOCH_DIFF = excelDate >= 1900 ? 25569 : 25568 // Adjust for 1900 vs 1904 epoch difference

      // Convert to milliseconds since epoch
      const milliseconds = (excelDate - EPOCH_DIFF) * 86400000

      // Create a new JavaScript Date object
      return moment(new Date(milliseconds), 'YYYY-MM-DD').format('YYYY-MM-DD')
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  }
}
</script>

<style scoped>
.hide-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
}
</style>
